export const TimeLineGroupStatus = {
    NOT_INITIATED: "0",
    IN_PROGRESS: "1",
    DONE: "2",
};

export interface Step {
    stepId?: string;
    stepSlug?: string;
    title: string;
    statusCode?: string;
    status: "not-initiated" | "completed" | "current" | "pending" | "failed" | "declined" | "in-verification";
    stepIcon: string;
    statusMsg: string;
    statusMsgIcon: string;
    msg: string;
    other?: any;
}

export enum StepStatus {
    // Grey
    NOT_INITIATED = "0",

    //Yellow
    PENDING_FROM_USER_SIDE_ACTION = "1",
    PENDING_FROM_USER_SIDE_2_ACTION = "2",
    PENDING_FROM_SERVER_SIDE = "3",
    IN_ANALYSIS = "11",

    // Red
    FAILED = "4",
    DECLINED = "5",

    //Green
    COMPLETED = "6",
    SKIP = "7",
}

export enum StepSlug {
    NB_BS_AG_ETC = "NB_BS_AG_ETC",
    VIDEO_KYC = "VIDEO_KYC",
    ESIGN_STEP = "ESIGN_STEP",
    PN_VERIF_STEP = "PN_VERIF_STEP",
    EMP_VERIFI_STEP = "EMP_VERIFI_STEP",
    ADDRESS_VERIFICATION_STEP = "ADDRESS_VERIFICATION_STEP",
    FINAL_VERIFICATION = "FINAL_VERIFICATION",
    CONTACT_VERFICATION_STEP = "CONTACT_VERFICATION_STEP",
    BANK_ACC_VERIF_STEP = "BANK_ACC_VERIF_STEP",
    LOAN_DISBURSEMENT = "LOAN_DISBURSEMENT",
    EMP_VERIFI_STEP_SS = "EMP_VERIFI_STEP_SS",
    ENACH_STEP = "ENACH_STEP",
    USER_APPROVAL_STEP = "USER_APPROVAL_STEP",
    CKYC_VERIF_STEP = "CKYC_VERIF_STEP",
    AADHAR_KYC_STEP = "AADHAR_KYC_STEP",
    PROFILE_RETAKE_STEP = "PROFILE_RETAKE_STEP",
    PROFILE_VERIFICATION_STEP = "PROFILE_VERIFICATION_STEP",
    KYC_STEP = "KYC_STEP",
}

export enum KycStep {
    NONE = "0",
    DIGI_LOCKER = "1",
    CURRENT_ADDRESS = "2",
    PAN = "3",
}

export enum ProfileVerification {
    NONE = "0",
    LIVENESS = "1",
    PROFILE_DETAILS = "2",
    EMAIL_VERIFICATION = "3",
}
